export function throttle( fn, ms ) {
  let blocked = false;
  return function() {
    if ( !blocked ) {
      blocked = true;
      fn.apply( this, arguments );
      setTimeout( () => {
        blocked = false;
      }, ms );
    }
  };
}

export function debounce( fn, wait, ctx ) {
  let timer = null;
  return function() {
    let len = arguments.length;
    let args = new Array( len );
    let i;

    if ( timer ) {
      window.clearTimeout( timer );
    }

    for ( i = 0; i < len; i++ ) {
      args[ i ] = arguments[ i ];
    }

    timer = window.setTimeout( function() {
      fn.apply( ctx || null, args );
    }, wait );
  };
}


/**
* Check whether an element is in the viewport by
* more than offset px.
*/
export function inViewport( element, offset = 0 ) {
  const { top, bottom } = element.getBoundingClientRect();

  const intersection = {
    t: bottom,
    b: window.innerHeight - top
  };

  return intersection.t > offset && intersection.b > offset;
}

export function checkForMobile() {
  return window.innerWidth <= 768 ? true : false;
}
